import type { ReactNode } from 'react';

import { Row, TrafficLight, Typography } from '@scaleaq/scaleui';
import { StatusLevel } from '@scaleaq/sitecontrol-lib';

import { statusLevelToIndicatorType } from '@/utils';
import { STATUS_LEVEL_DISPLAY_ORDER } from '@/utils/statusLevelDisplayOrder.ts';

type StatusLevelBreakdownProps = {
  breakdown: Record<StatusLevel, number>;
  rowGap: string;
  /** Omit for default (medium) traffic light. */
  trafficLightSize?: 'small' | 'medium';
  /** When set, shows a translated label before the count (toolbar). Otherwise count only (compact). */
  getLevelLabel?: (level: StatusLevel) => ReactNode;
};

export const StatusLevelBreakdown = ({
  breakdown,
  rowGap,
  trafficLightSize,
  getLevelLabel,
}: StatusLevelBreakdownProps) => (
  <>
    {STATUS_LEVEL_DISPLAY_ORDER.filter(level => breakdown[level] > 0).map(level => (
      <Row gap={rowGap} key={level}>
        <TrafficLight size={trafficLightSize} type={statusLevelToIndicatorType(level)} />
        {getLevelLabel && (
          <Typography type='body_medium' secondary>
            {getLevelLabel(level)}
          </Typography>
        )}
        <Typography type='body_medium' secondary={!getLevelLabel} weight={500}>
          {breakdown[level]}
        </Typography>
      </Row>
    ))}
  </>
);
